import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const ComingSoonSection = ({ items, onScrollToSection }) => (
  <section className="py-20 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 relative overflow-hidden">
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      <div className="absolute top-10 left-10 w-72 h-72 bg-cyan-500/5 rounded-full blur-3xl animate-pulse" />
      <div className="absolute bottom-10 right-10 w-96 h-96 bg-violet-500/5 rounded-full blur-3xl animate-pulse" style={{animationDelay: '1s'}} />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-cyan-400/3 rounded-full blur-3xl" />
      <div className="absolute inset-0" style={{backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.03) 1px, transparent 0)', backgroundSize: '40px 40px'}} />
    </div>

    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
      <div className="text-center mb-16">
        <div className="inline-flex items-center gap-2 bg-cyan-500/10 border border-cyan-500/20 rounded-full px-5 py-2 mb-6">
          <Sparkles className="h-4 w-4 text-cyan-400" />
          <span className="text-cyan-400 text-sm font-bold tracking-wide uppercase">Coming Soon</span>
          <Sparkles className="h-4 w-4 text-cyan-400" />
        </div>
        <h2 className="text-3xl md:text-4xl font-black text-white mb-4">What We're Building Next</h2>
        <p className="text-lg text-slate-400 max-w-2xl mx-auto">Our roadmap is driven by real industry needs. These modules are in active development and will be available soon.</p>
      </div>

      <div className="grid md:grid-cols-3 gap-8">
        {items.map((item, index) => {
          const IconComp = item.icon;
          return (
            <div key={index} className="group relative">
              <div className={`absolute -inset-0.5 bg-gradient-to-r ${item.gradientFrom} ${item.gradientTo} rounded-2xl opacity-0 group-hover:opacity-20 transition-opacity duration-500 blur`} />
              <div className={`relative bg-slate-800/80 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-8 h-full transition-all duration-300 ${item.hoverBorder} group-hover:translate-y-[-4px]`}>
                <div className="flex items-center justify-between mb-6">
                  <div className={`p-3 bg-gradient-to-br ${item.iconBg} rounded-xl border`}>
                    <IconComp className={`h-7 w-7 ${item.iconColor}`} />
                  </div>
                  <span className={`text-[10px] font-black tracking-widest uppercase ${item.badgeColor} px-3 py-1.5 rounded-full border`}>
                    In Development
                  </span>
                </div>
                <h3 className="text-xl font-black text-white mb-3">{item.title}</h3>
                <p className="text-slate-400 text-sm mb-6 leading-relaxed">{item.description}</p>
                <ul className="space-y-2.5">
                  {item.features.map((f, i) => (
                    <li key={i} className="flex items-center gap-2.5 text-sm text-slate-500">
                      <div className={`w-1 h-1 rounded-full ${item.dotColor}`} />
                      {f}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          );
        })}
      </div>

      <div className="text-center mt-12">
        <p className="text-slate-500 text-sm">Want early access or have a feature request?</p>
        <Button
          onClick={() => onScrollToSection('contact')}
          variant="outline"
          className="mt-3 border-slate-600 text-slate-300 hover:bg-slate-800 hover:text-white"
        >
          Get on the Waitlist <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </div>
    </div>
  </section>
);
